import React, { useEffect, useState } from "react";
import { Layout } from 'antd';
import { Link, useLocation, useParams } from 'react-router-dom';
import {  KoText } from "packages";
import KoIcon from '@kwapio/icons';
import { useSelector, useDispatch } from 'react-redux';
import styles from './layouts.module.scss';
import {
  APICLIENT_SUB_MENU,
  FILES_SUB_MENU,
  CALENDAR_SUB_MENU,
  CUSTOMERS_SUB_MENU
} from "./constant";
import { getOrgMenuForRoles } from "./orgmenu";
import { getAdminMenuForRoles } from "./adminmenu";
import { getInvoiceMenuForRoles } from "./financemenu";
import { getTimeSheetCount } from "shared/store/timesheetCountSlice";
import { getApprovalCount } from "shared/store/approvalCountSlice";
import { getLeaveCount } from "shared/store/leaveCountSlice";
import { getHomeMenuForRoles } from "./homemenu";
import { addDateRange, removeDateRange } from "shared/store/countDateRangeSlice";
import { getChatMenuForRoles } from "./chatmenu";
import { templateMenuGenerators } from "./workflowMenus";
import { getDateRange } from "shared/utils";

const { Sider } = Layout;

function GlobalSider(props) {
  const location = useLocation();
  const { pathname } = location;
  const { workspaceId } = useParams();
  const currentPath = pathname?.split('/')[1];
  const activeCurrentPath = workspaceId ? pathname?.split('/')[4] : pathname?.split('/')[2];
  const { background, collapsed } = props;
  const userById = useSelector(state => state?.userById);
  const timeSheetCount = useSelector(state => state?.timesheetCount);
  const apprCount = useSelector(state => state?.approvalCount);
  const [timeSheetCountData, setTimeSheetCountData] = useState(timeSheetCount?.data || 0);
  const [approvalCountData, setApprovalCountData] = useState(apprCount?.data?.totalCount || 0);
  const dispatch = useDispatch();
  let userDetails = userById['data'];

  let items = [];
  if (currentPath === 'org') {
    items = getOrgMenuForRoles(userDetails);
  } else if (currentPath === 'admin') {
    items = getAdminMenuForRoles(userDetails);
  } else if (currentPath === 'workspace' && userDetails?.roles) {
    if (pathname.includes('orders')) {
      const menuGenerator = templateMenuGenerators['orders'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    } else if (pathname.includes('sales')) {
      const menuGenerator = templateMenuGenerators['sales'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('events')) {
      const menuGenerator = templateMenuGenerators['events'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    } else if (pathname.includes('hr')) {
      const menuGenerator = templateMenuGenerators['hr'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('marketing')) {
      const menuGenerator = templateMenuGenerators['marketing'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('support')) {
      const menuGenerator = templateMenuGenerators['support'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('finance')) {
      const menuGenerator = templateMenuGenerators['finance'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('helpdesk')) {
      const menuGenerator = templateMenuGenerators['helpDesk'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else if (pathname.includes('assets')) {
      const menuGenerator = templateMenuGenerators['assets'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }else {
      const menuGenerator = templateMenuGenerators['development'];
      items = menuGenerator ? menuGenerator(userDetails) : [];
    }
  } else if (currentPath === 'paybooks') {
    items = getInvoiceMenuForRoles(userDetails);
  } else if (currentPath === 'dms') {
    items = FILES_SUB_MENU;
  } else if (currentPath === 'apiclient') {
    items = APICLIENT_SUB_MENU;
  } else if (currentPath === 'home' ||
    currentPath === 'huddle') {
    items = getHomeMenuForRoles(userDetails);
    if (userDetails?.roles?.includes(9)) {
      items = items.filter(item => item.key !== 'home/approvals/tms/dashboard');
    }
  } else if (currentPath === 'chat') {
    items = getChatMenuForRoles(userDetails);
  } else if (currentPath === 'engagements') {
    items = CALENDAR_SUB_MENU;
  }else if (currentPath === 'customers') {
    items = CUSTOMERS_SUB_MENU;
  }
  // let workspaceItems = [];
  // if (workspace['data']) {
  //   let wos = getCookie('wos');
  //   setCookie('wos', wos ? wos : workspace['data'][0]?.workspaceId);
  //   workspaceItems = workspace['data'];
  // }


  useEffect(() => {
    dispatch(removeDateRange());
    dispatch(addDateRange(getDateRange('currentYear')));
    dispatch(getTimeSheetCount());
    dispatch(getLeaveCount());
  }, []);

  useEffect(() => {
    setTimeSheetCountData(timeSheetCount?.data);
  }, [timeSheetCount]);



  useEffect(() => {
    dispatch(getApprovalCount());
  }, []);

  useEffect(() => {
    setApprovalCountData(apprCount?.data?.totalCount);
  }, [apprCount]);

  const keywords = ['orders', 'sales', 'hr', 'marketing', 'events', 'development', 'finance', 'helpdesk', 'support'];

  const isMatched = keywords.some(keyword => pathname.includes(keyword));
  const matchedKeyword = keywords.find(keyword => pathname.includes(keyword));

  return (
    <Sider
      style={{
        background: background
      }}
      className={styles.sideNavDesktop}
      trigger={null} collapsible collapsed={collapsed}
    >

      <ul className="badge">
        {/* {currentPath === 'home' && <li key={'kio-ai'} className={'/kio-ai'.includes(pathname) > 0 ? styles.active : ''}>
          <Link to={`/kio-ai`}>
            <KoIcon name='LoaderFilled' width={20} height={20} />
            <KoText ellipsis={true} className={styles.text} text={'Kio AI'} />
          </Link>
        </li>} */}

        {!isMatched && items.map((item) =>
          <li key={item.key} className={item.key.includes(activeCurrentPath) > 0 ? styles.active : ''}>
            <Link to={`${workspaceId ? '/workspace/' + workspaceId + '/' + item?.key : item?.key}`}>
              <KoIcon name={item?.icon} width={17} height={17}color={'#000'}/>
              <KoText ellipsis={true} className={styles.text} text={item.label} />
              {((item.label === 'Time Sheet' && timeSheetCountData > 0) || (item.label === 'Approvals' && approvalCountData > 0)) &&
               <div className={styles.badgeContainer}>
                 {item.label === 'Time Sheet' && timeSheetCountData > 0 &&
                  <div className={styles.badgeCount}>{timeSheetCountData}</div>}
                 {item.label === 'Approvals' && approvalCountData > 0 &&
                  <div className={styles.badgeCount}>{approvalCountData}</div>}
                
               </div>}
            </Link>
          </li>
        )}

        {isMatched &&
         items.map((item) =>
           <li key={item.key} className={item.key.includes(activeCurrentPath) > 0 ? styles.active : ''}>
             <Link to={`${workspaceId ? '/workspace/' + workspaceId + '/' + matchedKeyword + '/' + item?.key : item?.key}`}>
               <KoIcon name={item?.icon} width={17} height={17} color={'#000'} />
               <KoText ellipsis={true} className={styles.text} text={item.label} />
             </Link>
           </li>
         )
        }
      </ul>
    </Sider>


  );
}

export default GlobalSider;